import { render, staticRenderFns } from "./CardPlan.vue?vue&type=template&id=4712cfa0&scoped=true&"
import script from "./CardPlan.vue?vue&type=script&lang=js&"
export * from "./CardPlan.vue?vue&type=script&lang=js&"
import style0 from "./CardPlan.vue?vue&type=style&index=0&id=4712cfa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712cfa0",
  null
  
)

export default component.exports